import React, { useContext } from 'react';
import {
  Button,
  Text,
} from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { LoginErrorCard } from './login-error-card';

export type LoginErrorPageProps = {
  email?: string | null;
  onTryDifferentEmail: () => void;
  onCreateAccount: () => void;
};

export const LoginErrorPage: React.FC<LoginErrorPageProps> = ({
  email,
  onTryDifferentEmail,
  onCreateAccount,
}) => {
  const i18n = useContext(I18nContext);
  const description = email
    ? i18n.getString(
      _TL_('We don\'t see an account for {{email}}. Sign in with a different email, or create a new account.'),
      { email }
    )
    : i18n.getString(_TL_('We don\'t see a Microsoft Advertising account for this email. Sign in with a different email, or create a new account.'));

  return (
    <LoginErrorCard
      idPrefix="login-error"
      title={i18n.getString(_TL_('No Microsoft Advertising account found'))}
      actions={(
        <>
          <Button className="login-error-try-different-email" appearance="primary" onClick={onTryDifferentEmail}>
            {i18n.getString(_TL_('Try a different email'))}
          </Button>
          <Button className="login-error-create-account" appearance="secondary" onClick={onCreateAccount}>
            {i18n.getString(_TL_('Create new account'))}
          </Button>
        </>
      )}
    >
      <Text block>{description}</Text>
    </LoginErrorCard>
  );
};
